var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDucousersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18.417,
    r: 18,
    fill: "#2FE5A7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9546 18.7287C23.9546 20.0965 23.6999 21.24 23.1904 22.1593C22.6809 23.073 21.9417 23.7624 20.9726 24.2276C20.0035 24.6872 18.8351 24.917 17.4673 24.917H14.0948V12.773H17.8327C19.0898 12.773 20.1752 13 21.0889 13.4541C22.0026 13.9026 22.7086 14.5699 23.207 15.4559C23.7054 16.3364 23.9546 17.4273 23.9546 18.7287ZM21.878 18.7868C21.878 17.7901 21.7202 16.9705 21.4045 16.3281C21.0944 15.6858 20.6348 15.2095 20.0256 14.8994C19.422 14.5838 18.6772 14.4259 17.7912 14.4259H16.0884V23.2474H17.5005C18.968 23.2474 20.0644 22.8736 20.7898 22.126C21.5153 21.3784 21.878 20.2654 21.878 18.7868Z",
    fill: "#2FE5A7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDucousersIcon);
export default __webpack_public_path__ + "static/media/DucousersIcon.ad803fa5d7324e42f23813e85a1bb207.svg";
export { ForwardRef as ReactComponent };